import logo from '../assets/images/telsim-logo-rose-white.png';
import qrcode from '../assets/images/telsim-qr-code.png';
import Twitter from '../assets/images/Twitter.png';
import React from 'react';


function Footer() {
  return (
  

   <footer id="footer">

    <div className="footer-top">
      <div className="container">
        <div className="row">

          <div className="col-lg-4 col-md-6 footer-newsletter">
            <img src={logo} style={{height: '60px', marginBottom: '15px'}} />
            <p>We are dedicated to assisting customers in making informed decisions and contributing value to our communities. This commitment is reflected in our provision of seamless ultra-fast connectivity through top-tier NBN<sup>&reg;</sup> plans.</p>
            
          </div>

          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><i className="fa fa-angle-right" aria-hidden="true"></i> <a href="https://www.telsim.com.au/sim-cards/">Telsim Prepaid Mobile Plans</a></li>
              <li><i className="fa fa-angle-right" aria-hidden="true"></i> <a href="https://www.telsim.com.au/why-telsim/">Why Telsim</a></li>
              <li><i className="fa fa-angle-right" aria-hidden="true"></i> <a href="https://www.telsim.com.au/contact-us/">Contact Us</a></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i className="fa fa-angle-right" aria-hidden="true"></i> <a href="https://www.telsim.com.au/legals/">Legals</a></li>
              <li><i className="fa fa-angle-right" aria-hidden="true"></i> <a href="https://www.telsim.com.au/critical-information-summary/">Critical Information Summary</a></li>
              <li><i className="fa fa-angle-right" aria-hidden="true"></i> <a href="https://www.telsim.com.au/shipping-delivery/">Shipping and Delivery</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-6 footer-contact">
            <h4>Scan And Touch With Us</h4>
            <img src={qrcode} width="120px" height="120px" />
          </div>

        </div>
      </div>
    </div>

    <div className="container d-md-flex py-4">

      <div className="me-md-auto text-center text-md-start">
        <div className="copyright">
          Copyright © 2024 | Telsim Australia | Kangaroo Telecom Pty Ltd | All Rights Reserved | ABN 84 628 098 966
        </div>
      </div>
      <div className="social-links text-center text-md-end pt-3 pt-md-0">
        <a href="https://www.facebook.com/telsimaustralia" className="facebook"><i className="fa fa-facebook" aria-hidden="true"></i></a>
        <a href="https://www.instagram.com/telsimaustralia/" className="instagram"><i className="fa fa-instagram" aria-hidden="true"></i></a>
        <a href="https://twitter.com/TelsimAustralia" className="twitter"><img src={Twitter} style={{height: 'auto', width: '18px'}}></img></a>
        <a href="mailto:support@telsim.com.au" className="linkedin"><i className="fa fa-envelope" aria-hidden="true"></i></a>
      </div>
    </div>
  </footer>



  );
}

export default Footer;